import {
  getStartStreamFailedIds,
  getStopStreamFailedIds,
} from 'hooks/useStreamActionUtils/utils';
import {
  streamingActive,
  streamStartFailed,
  streamStopFailed,
} from 'hooks/useStreamButtonState/utils';
import { STREAM_STATUS_STOPPED } from 'constants/StreamStatus';

export function endStreamStartMetric(
  streamEndpoints,
  endStreamStartCallback,
  setIsStreamStartSLIActive
) {
  const isStreamStartFailed = streamStartFailed(streamEndpoints);
  const isStreaming = streamingActive(streamEndpoints);

  if (isStreamStartFailed) {
    const streamIds = getStartStreamFailedIds(streamEndpoints);
    endStreamStartCallback({
      error: `Error starting the stream, streamIds: ${streamIds}`,
    });
    setIsStreamStartSLIActive(false);
  }

  if (isStreaming) {
    endStreamStartCallback({
      streamId: streamEndpoints[0]._id,
    });
    setIsStreamStartSLIActive(false);
  }
}

export function endStreamStopMetric(
  streamEndpoints,
  endStreamStopCallback,
  setIsStreamStopSLIActive
) {
  const isStreamStopFailed = streamStopFailed(streamEndpoints);
  const isStopped = streamStopped(streamEndpoints);

  if (isStreamStopFailed) {
    const streamIds = getStopStreamFailedIds(streamEndpoints);
    endStreamStopCallback({
      error: `Error stopping the stream, streamIds: ${streamIds}`,
    });
    setIsStreamStopSLIActive(false);
  }

  if (isStopped) {
    endStreamStopCallback({
      streamId: streamEndpoints[0]._id,
    });
    setIsStreamStopSLIActive(false);
  }
}

function streamStopped(streamEndpoints) {
  return streamEndpoints.some(
    (endpoint) => endpoint.status === STREAM_STATUS_STOPPED
  );
}
